import { useEffect, useRef, useState } from "react";

import { UIMultilineTooltip } from "@/shared/ui/ui-multiline-tooltip";

import s from "./menu-styles.module.scss";

const useIsShowTooltip = (ref: React.RefObject<HTMLDivElement>, isEnableTooltip: boolean) => {
	const [open, setOpen] = useState(false);

	useEffect(() => {
		if (!isEnableTooltip) return;

		const rootMenuItem = ref.current?.closest(".ant-menu-item");

		const checkIsRootHovered = () => {
			const isHover = rootMenuItem?.classList.contains("ant-menu-item-active");
			setOpen(!!isHover);
		};

		const observer = new MutationObserver(checkIsRootHovered);

		if (rootMenuItem)
			observer.observe(rootMenuItem, { attributes: true, attributeFilter: ["class"] });

		return () => observer.disconnect();
	}, [isEnableTooltip, ref]);

	return open;
};

export const MenuTooltip = ({ tooltipMessage }: { tooltipMessage?: string }) => {
	const ref = useRef<HTMLDivElement | null>(null);
	const isOpenTooltip = useIsShowTooltip(ref, !!tooltipMessage);

	return (
		<UIMultilineTooltip
			className={s.menuItemTooltip}
			placement="right"
			title={tooltipMessage}
			open={isOpenTooltip}
		>
			<div className="absolute top-0 bottom-0 left-0 right-0 z-[-1]" ref={ref} />
		</UIMultilineTooltip>
	);
};
